export class themas {
  static colors = {
    "white": "#FFFFFF",
    "black": "#000000",
    "gray-500": "#A0A0A0",
    "surface-page": "#F0F0F0",
    "surface-soft": "#F8F8F8",
    "surface-muted": "#ECECEC",
    "brand-primary": "#19438C",
    "brand-secondary": "#AD8401",
    "accent-cyan": "#19438C",
    "danger": "#AD8401",
  };

  static applyTheme(overrides = {}) {
    if (typeof document === "undefined") return;

    const palette = { ...themas.colors, ...overrides };
    const root = document.documentElement;

    Object.entries(palette).forEach(([key, value]) => {
      root.style.setProperty(`--color-${key}`, value);
    });
  }

  static color(name) {
    return `var(--color-${name})`;
  }
}

export default themas;
